// Canonical column layout of the metadata Excel template. The uploaders map
// cells to fields by column index, so any sheet that doesn't carry exactly
// these headers must be rejected before blanks are treated as clears.
export const METADATA_TEMPLATE_HEADERS = [
  "Patent Number",
  "Country",
  "Kind Code",
  "Grant Date",
  "Applicant Name",
  "Inventor",
  "Application Filing Date",
  "Application Number",
  "Abstract/Translation File?",
];

// Blank cells must be sent as null (not undefined) so the API
// clears the existing value for that field.
export const normalizeCell = (value) => {
  if (value === undefined || value === null) return null;
  if (typeof value === "string" && value.trim() === "") return null;
  return value;
};

const cellText = (value) => {
  if (value === undefined || value === null) return "";
  if (typeof value === "object" && Array.isArray(value.richText)) {
    return value.richText.map((part) => part.text).join("");
  }
  return value.toString();
};

// A blank cell may only clear a stored value when its column is actually
// present in the sheet, so sheets from older/edited templates are rejected.
export const hasValidTemplateHeaders = (worksheet) => {
  const headerRow = worksheet.getRow(1).values.slice(1);
  return METADATA_TEMPLATE_HEADERS.every(
    (expected, index) =>
      cellText(headerRow[index]).trim().toLowerCase() === expected.toLowerCase()
  );
};

export const TEMPLATE_MISMATCH_MESSAGE =
  "The file's header row does not match the current metadata template. Please download the latest Metadata Template and try again.";
